/**
 * "3 adultos, 1 niño". Omite el que esté en cero y devuelve '' si no hay nadie,
 * para que cada pantalla decida qué mostrar en ese caso.
 */
export const formatGuests = (adults = 0, children = 0): string =>
  [
    adults > 0 ? `${adults} adulto${adults !== 1 ? 's' : ''}` : null,
    children > 0 ? `${children} niño${children !== 1 ? 's' : ''}` : null,
  ].filter(Boolean).join(', ');
